import { useMutation } from '@vue/apollo-composable';
import { computed } from 'vue';
import type { Order } from '@/types';
import { UPDATE_ORDER } from './graphql';

export const useCustomerActions = () => {
  const { mutate: addMutate, loading: addLoading } = useMutation(UPDATE_ORDER);
  const { mutate: removeMutate, loading: removeLoading } =
    useMutation(UPDATE_ORDER);

  const loading = computed(() => addLoading.value || removeLoading.value);

  const addCustomer = (orderId: string, customerId: number): Promise<Order> =>
    new Promise<Order>((resolve, reject) => {
      addMutate({
        input: {
          id: orderId,
          customerId,
        },
      })
        .then(
          ({
            data: {
              updateOrder: { order },
            },
          }) => {
            resolve(order);
          },
        )
        .catch(reject);
    });

  const removeCustomer = (orderId: string): Promise<Order> =>
    new Promise<Order>((resolve, reject) => {
      removeMutate({
        input: {
          id: orderId,
          customerId: null,
        },
      })
        .then(
          ({
            data: {
              updateOrder: { order },
            },
          }) => {
            resolve(order);
          },
        )
        .catch(reject);
    });

  return { addCustomer, removeCustomer, loading };
};
